import { recordVisit } from './src/utils/signupAttribution';
import { loadLanguage } from './src/i18n/config';

export { wrapPageElement, wrapRootElement } from './src/wrapElements';

// The page's translations are a separate chunk; hydrating before it arrives would render
// translation keys and mismatch the server HTML. <html lang> is set from the page's language.
// Look in `container`, not the whole document: gatsby develop also mounts its loading indicator
// with this function, into an empty element of its own that must not be hydrated.
export const replaceHydrateFunction = () => (element, container) => {
  const { hydrateRoot, createRoot } = require('react-dom/client');
  const focusEl = container.querySelector('#gatsby-focus-wrapper');
  let root;
  let unmounted = false;
  loadLanguage(document.documentElement.lang).then(() => {
    if (unmounted) return;
    if (focusEl && focusEl.children.length) {
      root = hydrateRoot(container, element);
    } else {
      root = createRoot(container);
      root.render(element);
    }
  });
  // Gatsby calls this to remove the loading indicator again.
  return () => {
    unmounted = true;
    root?.unmount();
  };
};

// Runs on the first page load and on every client-side navigation. There is no logged-in
// check: a sign-in here redirects straight to bloomstories.com, and importing Firebase
// for it would load the auth SDK and Google's sign-in iframe on every page.
export const onRouteUpdate = () => {
  recordVisit();
};
